$schoolSelectEl = $('#gradesSchoolId');
$gradesStatusSelectEls = $('.gradesStatusSelect');

$schoolSelectEl.selectize();

$schoolSelectEl.change((e) => e.target.form.submit());

$gradesStatusSelectEls.each(function(){
  let el = $(this);
  
  el.selectize();
});